const img = require('./ActiveColors.svg'); export default img;